import React, { useState } from "react";
import Banner from "../containers/Home/Banner";
import Client from "../containers/Home/Client";
import Service from "../containers/Home/ourServices";
import Testimonial from "../containers/Home/Testimonial";
import OurProject from "../containers/Home/ourProject";
import Featured from "../containers/Home/Featured";
import Arc from "../containers/Home/Arcshape"
const Home = () => {
  const [selected, setSelected] = useState(3);
console.log(selected,"selected")
  return (
    <div>
      <Banner />
      <Client />
      <Service />
      <div    className="bg-cover bg-center bg-no-repeat bg-fixed md:pt-5 pt-0"
      style={{
        backgroundImage: "url('/circle.png')",
      }}>
        <div className="md:hidden block">
      <OurProject selected={selected} setSelected={setSelected} />
      </div>
      <div>
      <Arc selected={selected} setSelected={setSelected} />
      </div>
      {selected && <Featured selected={selected} setSelected={setSelected} />}
      </div>
      <Testimonial />
    </div>
  );
};

export default Home;
